import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getUserSearchList: builder.query({
      query: ({ search = '', requestedPage = 0, requestedPageSize = 10 }) => ({
        url: `/api/v1/core/settings/users/search`,
        method: 'GET',
        params: {
          page: requestedPage,
          size: requestedPageSize,
          search,
        },
      }),
    }),
  }),
})

export const { useLazyGetUserSearchListQuery, useGetUserSearchListQuery } = extendedApi
